(function () {
  var backButton = document.querySelector('[data-back-button]')

  if (!backButton) {
    return
  }

  function normalizePath(path) {
    if (!path) {
      return '/'
    }

    var normalizedPath = path.toLowerCase()
    if (normalizedPath.length > 1 && normalizedPath.charAt(normalizedPath.length - 1) === '/') {
      normalizedPath = normalizedPath.slice(0, -1)
    }

    return normalizedPath
  }

  function isAppHomePage() {
    var hiddenPaths = ['/']

    return hiddenPaths.indexOf(normalizePath(window.location.pathname)) !== -1
  }

  function isMobileViewport() {
    return window.matchMedia('(max-width: 850px)').matches
  }

  function updateVisibility() {
    var isAppStoreHome = document.body && document.body.getAttribute('data-name') === 'app-store'
    var shouldShow = isMobileViewport() && !isAppHomePage() && !isAppStoreHome
    backButton.hidden = !shouldShow
  }

  function hasUsableHistory() {
    if (window.history.length <= 1) {
      return false
    }

    var referrer = document.referrer || ''

    if (!referrer) {
      return false
    }

    try {
      return new URL(referrer).origin === window.location.origin
    } catch (e) {
      return false
    }
  }

  function goBack() {
    var fallbackUrl = backButton.getAttribute('data-fallback-url') || '/'

    if (hasUsableHistory()) {
      window.history.back()
      return
    }

    window.location.assign(fallbackUrl)
  }

  updateVisibility()
  window.addEventListener('load', updateVisibility)
  window.addEventListener('resize', updateVisibility)

  backButton.addEventListener('click', function (event) {
    event.preventDefault()
    goBack()
  })

  backButton.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') {
      return
    }

    event.preventDefault()
    goBack()
  })
})()
